module.exports = __webpack_public_path__ + "img/Search@3x.15947d47.svg";